function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-e3c26408\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ViewNoteDetailsModal.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ViewNoteDetailsModal.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-e3c26408\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ViewNoteDetailsModal.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e3c26408",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/component/common/ViewNoteDetailsModal.vue
// module id = 2025
// module chunks = 0